import axios from 'axios';
import contentSort from '@/app/utils/contentSortingUtil';

import {
  SET_LINK_CIPHER,
  SET_ACTIVE_SHARED_VIEW,
  SET_APP_TYPE,
  SET_LINK_TYPE,
  SET_LINK_DETAILS,
  SET_FETCH_LINK_DETAILS_STATUS,
  SET_LINK_PASSWORD,
  SET_SETUP_LINK_PASSWORD_STATUS,
  SET_LINK_RESTORE_INFO,
  SET_FETCH_LINK_RESTORE_INFO_STATUS,
  SET_LINK_CONTENT_ITEMS,
  SET_FETCH_LINK_CONTENT_ITEMS_STATUS,
  SET_LINK_ROOT_FOLDER_NAME
} from './mutation-types';

import {
  SETUP_LINK_CIPHER,
  SHOW_SHARED_VIEW,
  UPDATE_APP_TYPE,
  FETCH_LINK_DETAILS,
  SETUP_LINK_PASSWORD,
  FETCH_LINK_RESTORE_INFO,
  FETCH_LINK_CONTENT_ITEMS,
  SORT_LINK_CONTENT_ITEMS
} from './action-types';

import {
  PENDING_STATUS,
  SUCCESS_STATUS,
  ERROR_STATUS,
  COMPLETED_STATUS,
  UNDEFINED_STATUS
} from './action-status';

import {
  SHARED_LINK_PASSWORD,
  SHARED_LINK_NOT_FOUND,
  RESTORE_SHARED_FILE,
  RESTORE_SHARED_FOLDER
} from './active-shared-view';

import {
  UNKNOWN
} from './app-type';

import {
  UNKNOWN_LINK_TYPE,
  FILE_LINK_TYPE,
  FOLDER_LINK_TYPE
} from './link-type';

const defaultSortOptions = { columnName: 'displayName', sortOrder: 'ascending' };
let contentTableSortOptions = defaultSortOptions;

const debug = process.env.NODE_ENV !== 'production';

function showLinkNotFoundView(commit) {
  commit(SET_APP_TYPE, UNKNOWN);
  commit(SET_LINK_TYPE, UNKNOWN_LINK_TYPE);
  commit(SET_ACTIVE_SHARED_VIEW, SHARED_LINK_NOT_FOUND);
}

function showLinkRestoreView(commit, isFolder) {
  commit(SET_ACTIVE_SHARED_VIEW, isFolder ? RESTORE_SHARED_FOLDER : RESTORE_SHARED_FILE);
}

export default {
  [SETUP_LINK_CIPHER]({ commit, dispatch }, linkCipher) {
    commit(SET_LINK_CIPHER, linkCipher);
  },
  [SHOW_SHARED_VIEW]({ commit, dispatch }, sharedView) {
    commit(SET_ACTIVE_SHARED_VIEW, sharedView);
  },
  [UPDATE_APP_TYPE]({ commit, dispatch }, appType) {
    commit(SET_APP_TYPE, appType);
  },
  async [FETCH_LINK_DETAILS]({ commit, dispatch }, sharedLink) {
    commit(SET_LINK_CIPHER, sharedLink.linkCipher);
    commit(SET_FETCH_LINK_DETAILS_STATUS, PENDING_STATUS);
    await axios.get('/linkDetails', {
      params: {
        linkCipher: sharedLink.linkCipher
      }
    })
      .then(function (response) {
        const details = debug ? response.data[0] : response.data;
        if (details === undefined || details.linkExists === undefined || !details.linkExists) {
          showLinkNotFoundView(commit);
        } else {
          commit(SET_LINK_DETAILS, details);
          commit(SET_APP_TYPE, details.appType);
          commit(SET_LINK_TYPE, details.folderItem ? FOLDER_LINK_TYPE : FILE_LINK_TYPE);

          if (details.passwordProtected) {
            commit(SET_ACTIVE_SHARED_VIEW, SHARED_LINK_PASSWORD);
          } else {
            showLinkRestoreView(commit, details.folderItem);
          }
        }
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 404) {
            showLinkNotFoundView(commit);
          }
        }
      })
      .finally(function () {
        commit(SET_FETCH_LINK_DETAILS_STATUS, COMPLETED_STATUS);
      });
  },
  async [SETUP_LINK_PASSWORD]({ commit, dispatch }, setupPasswordForm) {
    commit(SET_SETUP_LINK_PASSWORD_STATUS, PENDING_STATUS);
    commit(SET_LINK_PASSWORD, '');
    if (debug) {
      await setTimeout(function () {
        if (setupPasswordForm.password === '123') {
          commit(SET_SETUP_LINK_PASSWORD_STATUS, SUCCESS_STATUS);
          commit(SET_LINK_PASSWORD, setupPasswordForm.password);
          showLinkRestoreView(commit, setupPasswordForm.folderItem);
        } else {
          commit(SET_SETUP_LINK_PASSWORD_STATUS, ERROR_STATUS);
        }
      }, 1200);
    } else {
      await axios.put('/linkPassword', setupPasswordForm)
        .then(function () {
          commit(SET_SETUP_LINK_PASSWORD_STATUS, SUCCESS_STATUS);
          commit(SET_LINK_PASSWORD, setupPasswordForm.password);
          showLinkRestoreView(commit, setupPasswordForm.folderItem);
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status === 403) {
              commit(SET_SETUP_LINK_PASSWORD_STATUS, ERROR_STATUS);
            } else if (error.response.status === 404) {
              commit(SET_SETUP_LINK_PASSWORD_STATUS, UNDEFINED_STATUS);
              showLinkNotFoundView(commit);
            } else if (error.response.status !== 200) {
              commit(SET_SETUP_LINK_PASSWORD_STATUS, UNDEFINED_STATUS);
            }
          }
        });
    }
  },
  async [FETCH_LINK_RESTORE_INFO]({ commit, dispatch }, sharedLink) {
    commit(SET_FETCH_LINK_RESTORE_INFO_STATUS, PENDING_STATUS);
    await axios.get('/linkRestoreInfo', {
      params: {
        linkCipher: sharedLink.linkCipher,
        key: sharedLink.password
      }
    })
      .then(function (response) {
        const linkInfo = debug ? response.data[0] : response.data;
        commit(SET_LINK_RESTORE_INFO, linkInfo);
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 404) {
            showLinkNotFoundView(commit);
          }
        }
      })
      .finally(function () {
        commit(SET_FETCH_LINK_RESTORE_INFO_STATUS, COMPLETED_STATUS);
      });
  },
  async [FETCH_LINK_CONTENT_ITEMS]({ commit, dispatch }, selectedItem) {
    commit(SET_FETCH_LINK_CONTENT_ITEMS_STATUS, PENDING_STATUS);
    commit(SET_LINK_CONTENT_ITEMS, []);
    commit(SET_LINK_ROOT_FOLDER_NAME, '');

    await axios.get(debug ? '/content' : '/linkContent', {
      params: {
        linkCipher: selectedItem.linkCipher,
        key: selectedItem.password,
        path: selectedItem.path
      }
    })
      .then(function (response) {
        let content = [];
        if (debug) {
          content = response.data[0] !== undefined ? response.data[0].data : [];
        } else {
          content = response.data.data;
        }

        commit(SET_LINK_ROOT_FOLDER_NAME, debug ? 'RootItem' : response.data.rootFolderName);

        dispatch(SORT_LINK_CONTENT_ITEMS, {
          items: content,
          columnName: contentTableSortOptions.columnName,
          sortOrder: contentTableSortOptions.sortOrder
        });
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 404) {
            showLinkNotFoundView(commit);
          }
        }
      })
      .finally(function () {
        commit(SET_FETCH_LINK_CONTENT_ITEMS_STATUS, UNDEFINED_STATUS);
      });
  },
  [SORT_LINK_CONTENT_ITEMS]({ commit, dispatch }, data) {
    contentTableSortOptions = {
      columnName: data.columnName,
      sortOrder: data.sortOrder
    };
    const sortedItems = contentSort(data.items, data.columnName, data.sortOrder);
    commit(SET_LINK_CONTENT_ITEMS, sortedItems);
  }
};
